import { userStateActionType } from 'client/systemusers/constants/SystemUserConstants';
import ActionType from 'client/systemusers/util/ActionType';
import Constants, { ItemTypeConsts, ItemTypeLabels } from 'client/util/Constants';
import DateUtil from 'client/util/DateUtil';

const { ActivateAction, SuspendAction } = ActionType;
const activateAction = new ActivateAction();
const suspendAction = new SuspendAction();
const { activate, suspend } = userStateActionType;
const { success } = Constants;

const displayName = ItemTypeLabels[ItemTypeConsts.systemUser];

// Defaults for activation button groups
const activationOptionTypes = {
  schedule: { label: 'Schedule Activation', value: 'schedule' },
  now: { label: 'Activate Now', value: 'now' },
  later: { label: 'Activate Later', value: 'later' },
};

// Defaults for suspension button groups
const suspensionOptionTypes = {
  schedule: { label: 'Schedule Suspension', value: 'schedule' },
  now: { label: 'Suspend Now', value: 'now' },
};

/**
 * Display notification to admin depending on type of activation
 */
const generateActivationNotification = (
  messageType,
  option,
  userName,
) => {
  let message;
  let title;

  if (option === activationOptionTypes.schedule.value) {
    title = messageType === success ? 'Scheduled' : 'Error';
    message = messageType === success
      ? `${activateAction.descriptionTitle} scheduled for ${userName}.`
      : `Unable to schedule ${activateAction.description} for ${displayName}.`;
  } else if (option === activationOptionTypes.now.value) {
    title = messageType === success ? 'Saved' : 'Error';
    message = messageType === success
      ? `${userName} ${activateAction.userState} successfully.`
      : `Error updating ${displayName}.`;
  } else if (option === activationOptionTypes.later.value) {
    title = 'Saved';
    message = `${userName} saved successfully.`;
  }

  return { message, title };
};

/**
 * Display notification to admin depending on type of suspension
 */
const generateSuspensionNotification = (
  messageType,
  option,
  usernameOrCount,
) => {
  let message;
  let title;

  if (option === suspensionOptionTypes.schedule.value) {
    title = messageType === success ? 'Scheduled' : 'Error';
    message = messageType === success
      ? `${suspendAction.descriptionTitle} scheduled for ${usernameOrCount}.`
      : `Unable to schedule ${suspendAction.description} for ${displayName}.`;
  } else if (option === suspensionOptionTypes.now.value) {
    title = messageType === success ? 'Saved' : 'Error';
    message = messageType === success
      ? `${usernameOrCount} ${suspendAction.userState} successfully.`
      : `Error updating ${displayName}.`;
  } else if (option === suspensionOptionTypes.later.value) {
    title = 'Saved';
    message = `${usernameOrCount} saved successfully.`;
  }

  return { message, title };
};

// Default date and time for scheduled events
const setDefaultActionDate = (type) => {
  const now = new Date();
  const defaultDate = DateUtil.add(now, 1, 'days').toDate();

  if (type === activate) {
    // Set default date to tomorrow at 8am
    defaultDate.setHours(8, 0, 0, 0);
  } else if (type === suspend) {
    // Set default date to tomorrow at 5pm
    defaultDate.setHours(17, 0, 0, 0);
  }

  return defaultDate;
};

export default {
  activationOptionTypes,
  generateActivationNotification,
  generateSuspensionNotification,
  setDefaultActionDate,
  suspensionOptionTypes,
};
